import React from "react";
import ReactDOM from "react-dom";
import { CSSTransition } from "react-transition-group";
import CloseIcon from "@mui/icons-material/Close";

import Backdrop from "./Backdrop";
import "./Modal.css";

const ModalOverlay = (props) => {
  const content = (
    <div className={`modal ${props.className}`} style={props.style}>
      <header className={`modal__header ${props.headerClass}`} style={props.headerStyle}>
        <h3>{props.header}</h3>
        {props.onClose && (
          <button className="modal__close-button" onClick={props.onCancel}>
            <CloseIcon fontSize="inherit" />
          </button>
        )}
      </header>
      <div className={`modal__content ${props.contentClass}`}>{props.children}</div>
      {props.footer && <footer className={`modal__footer ${props.footerClass}`}>{props.footer}</footer>}
    </div>
  );
  return ReactDOM.createPortal(content, document.getElementById("modal-hook"));
};

const Modal = (props) => {
  return (
    <React.Fragment>
      {props.show && <Backdrop onClick={props.onCancel} />}
      <CSSTransition in={props.show} mountOnEnter unmountOnExit timeout={200} classNames="modal">
        <ModalOverlay {...props} />
      </CSSTransition>
    </React.Fragment>
  );
};

export default Modal;
